<template>
  <form class="t-delete" @submit.stop.prevent="Submit()">
    <h2>{{ staticText.title }}</h2>
    <p class="t-delete__text" >
        {{ staticText.text }} «{{props.name}}»?
    </p>
    <button class="t-btn" type="botton" @click.prevent="modalDialogClose()"><span> {{ staticText.btnChancel }} </span></button>
    <button class="t-btn t-btn_white"><span> {{ staticText.btn }} </span></button>
  </form>
</template>

<script>
    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export default {
        data(){
            return{
                disabledBtn: false,
                action: 'dialog/edit',
            }
        },
        computed: {
            ...mapGetters(['mobile']),
            ...mapGetters('staticText', ['removeDialog', 'leaveDialog']),
            staticText(){
                if( this.props.type == 'remove' ){
                    return this.removeDialog
                } else if( this.props.type == 'leave' ){
                    return this.leaveDialog
                }
                return this.leaveDialog
            }
        },
        props: ['props'],
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            Submit(){
                this.$http.delete(this.action, {params:{id:this.props.id}})
                    .then(response => response.json())
                    .then(data => {
                        this.modalDialogClose();
                        this.showMsg(this.staticText.msgSuccess);
                        this.$router.push({name: 'dialog', query: {sel: 'all'}});
                    }, data => {
                        this.modalDialogClose();
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            Focus(i){
                this.form[i].error = false
            }
        }
    }
</script>

<style lang="sass">
.t-delete
  width: 320px
  margin: 0 auto
  background: #ffffff
  padding: 24px
  border-radius: 16px
  &__text
    font-size: 16px
    margin-bottom: 16px
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/DialogRemove.vue